import { render } from "./Documentacion.vue?vue&type=template&id=791d97ac&scoped=true"
import script from "./Documentacion.vue?vue&type=script&lang=js"
export * from "./Documentacion.vue?vue&type=script&lang=js"

import "./Documentacion.vue?vue&type=style&index=0&id=791d97ac&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791d97ac"]])

export default __exports__